import { event_button_click } from '@/utils/gtm';
import NextLink from '@/components/next-link';
import Image from '@/components/image';

const DownloadApp = ({ appLinks }) => {
  const appStores = [
    {
      type: 'play-store',
      url: appLinks?.['url-play-store'],
      image: appLinks?.['img-play-store'],
      title: appLinks?.['title-play-store'],
    },
    {
      type: 'app-store',
      url: appLinks?.['url-app-store'],
      image: appLinks?.['img-app-store'],
      title: appLinks?.['title-app-store'],
    },
  ];

  const AppStoreLink = ({ store }) => {
    if (!store?.url || !store?.image) return null;

    return (
      <NextLink
        className='transition-all hover:translate-y-[-2px]'
        target='_blank'
        href={store.url}
        onClick={() =>
          event_button_click({
            button_name: store.type === 'app-store' ? 'App Store' : 'Google Play',
            button_destination: store.url,
            button_location: 'footer',
          })
        }
      >
        <Image
          src={store.image}
          alt={`${store.title || store.type} icon`}
          width={130}
          height={39}
          className='h-[39px] w-[130px] lg:h-[50px] lg:w-[165px]'
        />
      </NextLink>
    );
  };

  return (
    <div className='mt-3 flex items-center gap-[13px] max-lg:justify-center'>
      {appStores?.map((store) => (
        <AppStoreLink key={store.type} store={store} />
      ))}
    </div>
  );
};

export default DownloadApp;
